import React from "react"
import ContentSection from "../ContentSection"
import Button from "../core/Button/Button"

import { ReactComponent as ChampionsIllustration } from '../../../assets/images/habitacional/champions-illustration.svg'
import Description from "./Description"

const CtaDrawResults = ({isMaisPremiavel}) => {


    return (
        <ContentSection
            title="Sorteios"
            description={<Description isMaisPremiavel={isMaisPremiavel}/>}
            illustration={<ChampionsIllustration />}
        >
            <Button variant="muted-primary" style={{ marginTop: "32px" }}>
                Ver resultados
            </Button>
        </ContentSection>
    )
}

export default CtaDrawResults